// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__oS+K-","load4":"Spinner_load4__F3CbS"};